module.exports = __webpack_public_path__ + "img/Dantam Bridal 27.bcbcd9b8.jpg";